/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/prefer-default-export */
import React, { useState, useCallback, useEffect } from 'react'
import { checkEmail } from 'helpers/util'

import clsx from 'clsx'

import glassesImg from 'images/illustrations/glasses.png'
import nooklynLogoImg from 'images/nooklyn-logo.svg'
import DateSelection from './steps/DateSelection'
import Success from './steps/Success'
import FullNameInput from './steps/FullNameInput'
import EmailInput from './steps/EmailInput'
import PhoneNumberInput from './steps/PhoneNumberInput'
import s from './BookTour.module.css'

export function BookTour({ property, type, closeModal, currentUser, collectionId }) {
  const initialFullName = currentUser && currentUser.name ? currentUser.name : ''
  const initialEmail = currentUser && currentUser.email ? currentUser.email : ''
  const initialPhoneNumber = currentUser && currentUser.phone ? currentUser.phone : ''

  const [fullName, setFullName] = useState(initialFullName)
  const [fullNameError, setFullNameError] = useState(false)
  const [email, setEmail] = useState(initialEmail)
  const [emailError, setEmailError] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState(initialPhoneNumber)
  const [scheduleDate, setScheduleDate] = useState(undefined)
  const [showUserMessage, setShowUserMessage] = useState(false)
  const [userMessage, setUserMessage] = useState('')

  const [successStep, setSuccessStep] = useState(false)
  const [submitError, setSubmitError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    setFullNameError(false)
  }, [fullName])

  useEffect(() => {
    setEmailError(false)
  }, [email])

  const checkFullName = () => {
    return fullName.substr(0, fullName.indexOf(' ')).length && fullName.substr(fullName.indexOf(' ') + 1).length
  }
  const validData = () => {
    if (currentUser) {
      return true
    }

    let valid = true
    if (checkEmail(email)) {
      setEmailError(false)
    } else {
      setEmailError(true)
      valid = false
    }

    if (checkFullName(fullName)) {
      setFullNameError(false)
    } else {
      setFullNameError(true)
      valid = false
    }

    return valid
  }

  const handleSubmit = useCallback(
    async (e) => {
      try {
        if (validData()) {
          e.preventDefault()
          setSubmitting(true)
          setSubmitError('')

          const formData = new FormData()

          const messageNote = `${userMessage ? `Message: ${userMessage}.` : ''}`
          const firstName = fullName.substr(0, fullName.indexOf(' '))
          const lastName = fullName.substr(fullName.indexOf(' ') + 1)

          const jsonData = {
            listing_collection_id: collectionId,
            lead: {
              first_name: firstName,
              last_name: lastName,
              email,
              phone: phoneNumber,
              move_in: new Date(scheduleDate).toISOString(),
              notes: messageNote,
            },
          }

          console.log('json', jsonData)

          formData.append('listing_collection_id', jsonData.listing_collection_id)
          formData.append('lead[first_name]', jsonData.lead.first_name)
          formData.append('lead[last_name]', jsonData.lead.last_name)
          formData.append('lead[email]', jsonData.lead.email)
          formData.append('lead[phone]', jsonData.lead.phone)
          formData.append('lead[move_in]', jsonData.lead.move_in)
          formData.append('lead[notes]', jsonData.lead.notes)

          const apiToken = localStorage.getItem('apiToken')

          const response = await fetch(`/api/v3/listing_collection_leads.json`, {
            headers: {
              API_TOKEN: apiToken,
            },
            method: 'POST',
            body: formData,
          })

          const data = await response.json()
          console.log('lead', data)
          setSubmitting(false)
          setSuccessStep(true)
        }
      } catch (error) {
        console.log(error)
        setSubmitting(false)
        setSubmitError('We were unable to connect you to an agent. Please try again.')
      }
    },
    [email, fullName, userMessage, phoneNumber, scheduleDate, collectionId]
  )

  const handleRenterGuide = () => {
    window.location = '/guides/renter'
  }

  return (
    <div className={clsx(s.root, 'dark-mega-container apply-dark-container')}>
      <div className="request-tour container">
        {!successStep && (
          <>
            <i className="nookons-close close-btn" onClick={closeModal} />
            <div className="tour-modal-brank-container">
              <a href="/">
                <img alt="Nooklyn's wordmark" src={nooklynLogoImg} className="modal-brand d-block d-sm-none" />
              </a>
            </div>
            <div className="divider d-block d-sm-none" />
            <img alt="glasses" src={glassesImg} className="img-fluid mx-auto glasses" />
            <h1>Book Tour</h1>
            <FullNameInput initialValue={initialFullName} onChange={setFullName} error={fullNameError} />
            <EmailInput initialValue={initialEmail} onChange={setEmail} error={emailError} />
            <PhoneNumberInput initialValue={initialPhoneNumber} onChange={setPhoneNumber} />
            <DateSelection initialDate={undefined} onChange={setScheduleDate} />
            <div className="user-message-container">
              {showUserMessage ? (
                <div>
                  <label>
                    Message <span className="detail">(optional)</span>
                  </label>
                  <textarea
                    name="message"
                    className="general-text-field-dark form-control"
                    maxLength="200"
                    onChange={(e) => setUserMessage(e.target.value)}
                  />
                </div>
              ) : (
                <div
                  onClick={() => {
                    setShowUserMessage(true)
                  }}
                >
                  <span className="add-message">+ Add Message</span>
                  <span className="detail"> (optional)</span>
                </div>
              )}
            </div>
            <button
              className={`button btn-yellow-black btn-rounded text-left ${submitting ? 'disabled' : ''}`}
              type="submit"
              onClick={handleSubmit}
              disabled={submitting}
            >
              {submitting ? 'Booking...' : 'Book Tour'}
            </button>
            {submitError ? (
              <div className="submit-error">We were unable to connect you to an agent. Please try again.</div>
            ) : null}
            <div className="legal">
              <span>
                By clicking <b>Book Tour</b>, you agree to our{' '}
              </span>
              <a href="/terms" target="_blank">
                Terms of Service
              </a>
              <span> and </span>
              <a href="/privacy" target="_blank">
                Privacy Policy
              </a>
            </div>
          </>
        )}
        {successStep && (
          <>
            <Success onBack={closeModal} />
            <div className="border-0 text-center">
              <div className="tour-notes pb-3">Not sure what to expect when renting an apartment?</div>
              <div
                className="renter-guide-footer"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleRenterGuide()
                  }
                }}
                onClick={handleRenterGuide}
              >
                <span className="pr-1 align-middle" style={{ fontWeight: '500' }}>
                  Read the Renter&apos;s Guide
                </span>
                <i className="nookons-chevron-right align-middle" style={{ fontWeight: '500' }} />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
